module.exports = __webpack_public_path__ + "images/emoji/ring.9531d00e47234717ee32.png";